import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FINISHES } from "@/lib/content";
import { easeOut } from "@/components/Reveal";

export default function FinishLibrary() {
  const [active, setActive] = useState(0);
  const f = FINISHES[active];

  return (
    <div data-testid="finish-library" className="grid md:grid-cols-[340px_1fr]" style={{ border: "1px solid var(--line)" }}>
      {/* tabs */}
      <div className="flex md:flex-col overflow-x-auto md:overflow-visible" style={{ borderRight: "1px solid var(--line)" }}>
        {FINISHES.map((item, i) => (
          <button
            key={item.id}
            data-testid={`finish-tab-${item.id}`}
            onClick={() => setActive(i)}
            className="flex items-center gap-4 text-left px-7 py-6 whitespace-nowrap md:whitespace-normal transition-colors"
            style={{
              borderBottom: "1px solid var(--line)",
              color: active === i ? "var(--brass-bright)" : "var(--stone)",
              background: active === i ? "rgba(201,162,75,0.06)" : "transparent",
              fontFamily: "Fraunces, serif",
              fontSize: 19,
            }}
          >
            <span className="shrink-0 rounded-full" style={{ width: 26, height: 26, background: item.dot, border: "1px solid rgba(239,230,211,0.25)" }} />
            <span>{item.name}</span>
            <span className="font-mono-lbl text-[11px] ml-auto hidden md:block" style={{ color: "var(--stone-dim)" }}>{item.num}</span>
          </button>
        ))}
      </div>

      {/* display */}
      <div className="p-8 sm:p-14 grid gap-10 sm:gap-12 md:grid-cols-2 md:items-center">
        <AnimatePresence mode="wait">
          <motion.div
            key={f.id + "-img"}
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: easeOut }}
            className="relative aspect-square overflow-hidden"
            style={{ border: "1px solid var(--line)", boxShadow: "inset 0 0 60px rgba(0,0,0,0.5), 0 30px 60px -20px rgba(0,0,0,0.6)" }}
          >
            <img src={f.image} alt={f.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(135deg, rgba(255,255,255,0.14), transparent 40%, transparent 60%, rgba(0,0,0,0.35))" }} />
          </motion.div>
        </AnimatePresence>

        <AnimatePresence mode="wait">
          <motion.div
            key={f.id + "-info"}
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.45, ease: easeOut }}
          >
            <div className="font-mono-lbl text-[11px] mb-3" style={{ color: "var(--stone-dim)" }}>{f.kicker}</div>
            <h3 className="font-serif text-3xl mb-3" style={{ color: "var(--champagne)" }}>{f.title}</h3>
            <p className="text-[15px] leading-relaxed mb-6" style={{ color: "var(--stone)" }}>{f.body}</p>

            <div>
              {f.specs.map(([k, v], idx) => (
                <div key={k} className="flex justify-between py-3 text-[12.5px]" style={{ borderTop: "1px solid var(--line)", borderBottom: idx === f.specs.length - 1 ? "1px solid var(--line)" : "none" }}>
                  <span style={{ color: "var(--stone-dim)" }}>{k}</span>
                  <span className="font-mono-lbl !tracking-[0.06em] text-[11.5px]" style={{ color: "var(--champagne)" }}>{v}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-2 mt-6">
              {f.tags.map((t) => (
                <span key={t} className="text-[10.5px] tracking-[0.05em] px-3 py-[7px]" style={{ border: "1px solid var(--line)", color: "var(--stone)" }}>{t}</span>
              ))}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
